// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1WebhookSchema } from './v1/webhookSchema';

export const listWebhooksPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listWebhooksQueryParamsSchema = z.object({
  limit: z.optional(z.number().int().describe("Maximum number of webhooks to return")),
  offset: z.optional(z.number().int().describe("Number of webhooks to skip")),
}).optional();

export const listWebhooksHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Webhooks list retrieved successfully
 */
export const listWebhooks200Schema = z.array(z.lazy(() => v1WebhookSchema));

/**
 * @description Unauthorized
 */
export const listWebhooks401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listWebhooksQueryResponseSchema = z.lazy(() => listWebhooks200Schema);
